/**
 * Immediately instantiated.
 * 
 * Queries all elements with attributes `diff-from diff-sub`.
 * BOTH must be present. Optionally add a third attribute `diff-add`.
 * Whatever is inside that optional attribute will be appended to the diff value.
 * But only if the target element is not of type=number or Chrome refuses to update the value,
 * since "-2,32" is technically not a real number (-2.32, on the other hand, is).
 * 
 * Example usage:
 * <input class="border" type="text" id="testFrom">
 * <input class="border" type="number" id="testSub">
 * <input class="border" type="text" diff-from="#testFrom" diff-sub="#testSub" readonly>
 * <span class="mx-2 text-white bg-black border" type="text" diff-from="#testFrom" diff-sub="#testSub" diff-add=" Schmeckles"></span>
 * 
 * Will take the value from #testFrom, subtract the value from #testSub and writes it into the input as well as into the span.  
 * The span gets " Schmeckles" added to the value.
 */
let DiffInput = (function () {
    let DiffInput = function() {
		this.elements = {};
	};

	DiffInput.prototype.push = function(id, element) {
		if (typeof(this.elements[id]) !== 'undefined') {
			throw('Element exists already');
		}

		this.elements[id] = element;
	};

	DiffInput.prototype.pop = function(id) {
		if (typeof(this.elements[id]) === 'undefined') {
			throw('Cannot remove what doesn\'t exist');
		}

		delete this.elements[id];
	};

	DiffInput.prototype.get = function(id) {
		if (typeof(this.elements[id]) === 'undefined') {
			return undefined;
		}

		return this.elements[id];
	};

	DiffInput.prototype.getUniqueIdentifier = function() {
		let uuid;
		do {
			uuid = 'd' + Math.random().toString(36).substr(2, 10);
		} while (this.get(uuid) != undefined);
		return uuid;
	};

	DiffInput.prototype.update = function(id) {
		let el = this.get(id);
		if (!el) { return; }

		try {
			let fFromValue = parseFloat(el[1].value.toString().replace(',', '.')).toFixed(2);
			let fSubValue = parseFloat(el[2].value.toString().replace(',', '.')).toFixed(2);
			let newVal = (fFromValue-fSubValue).toFixed(2);
			if (isNaN(newVal)) {
				newVal = '';
				el[0].classList.remove('ng-not-empty');
			} else {
				el[0].classList.add('ng-not-empty');
			}

			switch(el[0].nodeName.toLocaleLowerCase()) {
				case 'textarea':
					el[0].value = newVal.toString().replace('.', ',') + el[3];
				break;

				case 'input':
					if (el[0].getAttribute('type') === 'number') {
						el[0].value = newVal;
					} else {
						el[0].value = newVal.toString().replace('.', ',') + el[3];
					}
				break;

				default:
					el[0].innerHTML = newVal;
				break;
			}

			// Custom Validation to trigger, only if both inputs are present
			let ev = el[0].getAttribute('validate-trigger');
			if (ev && !isNaN(fFromValue) && !isNaN(fSubValue)) {
				window.dispatchEvent(new CustomEvent(ev));
			}
		} catch (e) {
			//
		}
	};

	let instance = new DiffInput();
	let targetFields = Array.prototype.slice.call(document.querySelectorAll('[diff-from][diff-sub]'));
	targetFields.forEach(el => {
		let vI = el.getAttribute('diffing');
		if (!!vI) { return; }

		let from = document.querySelector(el.getAttribute('diff-from'));
		let sub = document.querySelector(el.getAttribute('diff-sub'));
		if (!from || !sub) { return; }
		let append = el.getAttribute('diff-add') || '';

		let uuid = instance.getUniqueIdentifier();
		el.setAttribute('diffing', uuid);
		instance.push(uuid, [ el, from, sub, append ]);

		from.addEventListener('keyup', () => {
			instance.update(uuid);
		});
		from.addEventListener('wheel', e => e.preventDefault());

		sub.addEventListener('keyup', function() {
			instance.update(uuid);
		});
		sub.addEventListener('wheel', e => e.preventDefault());
	});

	return instance;
})();